import {
  customerAccessTokenCreateMutation,
  customerQuery,
  customerAddressCreateMutation,
  customerCreateMutation,
  customerRecoverMutation,
  customerResetByUrlMutation,
  customerActivateByUrlMutation,
} from '../gql'

export const buildCustomerMethods = (graphQLClient) => ({
  async getCustomerAccessToken({ email, password }) {
    const variables = {
      input: {
        email,
        password,
      },
    }

    const data = {
      query: customerAccessTokenCreateMutation,
      variables,
    }

    const {
      data: {
        customerAccessTokenCreate: { customerAccessToken, customerUserErrors },
      },
    } = await graphQLClient(data)

    if (customerUserErrors?.length) {
      return { customerUserErrors }
    }

    return { customerAccessToken }
  },
  async createCustomer(input) {
    const data = {
      query: customerCreateMutation,
      variables: {
        input,
      },
    }

    const {
      data: {
        customerCreate: { customer, customerUserErrors },
      },
    } = await graphQLClient(data)

    return { customer, customerUserErrors }
  },
  async getCustomer(accessToken) {
    if (!accessToken) {
      return 'No access token'
    }

    return await graphQLClient({
      query: customerQuery(accessToken),
    })
  },
  async addressCreate({ customerAccessToken, address }) {
    return await graphQLClient({
      query: customerAddressCreateMutation,
      variables: {
        address,
        customerAccessToken,
      },
    })
  },
  async recoverCustomer({ email }) {
    return await graphQLClient({
      query: customerRecoverMutation,
      variables: {
        email,
      },
    })
  },
  async customerResetByUrl({ password, resetUrl }, storeOverride) {
    return await graphQLClient(
      {
        query: customerResetByUrlMutation,
        variables: {
          password,
          resetUrl,
        },
      },
      storeOverride,
    )
  },
  async customerActivateByUrl({ password, activationUrl }, storeOverride) {
    const query = {
      query: customerActivateByUrlMutation,
      variables: {
        password,
        activationUrl,
      },
    }
    return {
      response: await graphQLClient(query, storeOverride),
      query,
    }
  },
})
